// Common Client V2 imports
const { createFeedActions } = require('client-v2/common/containers/feed/actions')
// Sibling imports
const feedSelectors = require('./selectors')

module.exports = createFeedActions(feedSelectors)
